import { apiPost } from '@/lib/http/client';
import { logger } from '@/lib/logger';

import { VIEW_HEALTH_BEACON_TIMEOUT_MS, VIEW_HEALTH_ENDPOINT } from './config';
import type { ViewHealthBeaconPayload } from './types';

export function sendViewHealthBeacon(payload: ViewHealthBeaconPayload): void {
  // Debug log gated by window.__ahoy.enable() — see @/lib/logger. Makes
  // manual testing easy: enable the flag and every beacon shows in the
  // console with its scope, outcome, and duration.
  logger.debug('View health beacon sent', {
    scope_type: payload.scope_type,
    scope_name: payload.scope_name,
    outcome: payload.outcome,
    duration_ms: payload.duration_ms,
    error_type: payload.error_type,
    markers_missing: payload.markers_missing,
    // Only populated on `outcome: 'success'` for variant-based routes — lets
    // manual testing show which scenario settled the scope (e.g. LOADED vs
    // PROPOSAL_LOADED on `actions/*`).
    success_variant: payload.success_variant,
    entity_type: payload.entity_type,
  });

  apiPost(VIEW_HEALTH_ENDPOINT, payload, VIEW_HEALTH_BEACON_TIMEOUT_MS).catch(
    (err: unknown) => {
      logger.warn('View health beacon failed', { error: String(err) });
    }
  );
}
